/** WorkflowsPage 文案 */
export const WORKFLOWS_PAGE_COPY = {
  title: 'AI 工作流',
  createWorkflow: '新建工作流',
  myWorkflows: '我的工作流',
  noSavedWorkflows: '还没有保存自己的工作流，可先试用上方系统模板。',
  enterBuilder: '进入编排',
  cancel: '取消',
  nameLabel: '名称',
  typeLabel: '类型',
  remarkLabel: '备注',
  remarkPlaceholder: '可选',
  workflowTypeAria: '工作流类型',
  runWorkflow: '运行工作流',
  startRun: '开始运行',
  runHint: '将创建真实工作流运行并调用对应模型；创建后会进入运行页并通过 SSE 同步状态。',
  runMissingField: '请先填写必填运行输入',
  simulateRun: '试运行',
  startSimulate: '开始模拟',
  navigating: '跳转中…',
  simulateHint: '本地模拟执行，不调用 LLM / 生图模型，用于预览运行页布局与产物展示。',
  preflightChecking: '正在检查工作流图…',
  loadFailed: '加载失败',
  loadWorkflowsFailed: '加载工作流失败',
  nameRequired: '请填写工作流名称',
  invalidWorkflowLink: '工作流链接无效，请刷新列表后重试',
  noRunPermission: '当前账号无权运行工作流',
  invalidRunLink: '运行链接无效，请从列表重新进入',
  clonedSuccess: '已复制到你的工作流',
  cloneFailed: '复制失败',
  listUpdated: '工作流已更新',
} as const
